import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
import React from 'react';
import CommissionReport from './CommissionReport';
const CommissionReportWrapper = () => {
const userPermissions = useGetPermissions('commissionReport')||[];
     return userPermissions ? (  
        <div>
            <CommissionReport userPermissions={userPermissions}/>
        </div>
    ): (
            <PermisionDenied/>
        );
}
 
export default CommissionReportWrapper;